<h6
  id="editSiteNameBtn"
  data-m-target="Edit site name dropdown button"
  class="dropdownItem"
  (click)="editSiteName()"
>
  {{ 'edit_site_name' | ppTranslate }}
</h6>

@if (dropdown.data && user) {
  @if (importExcelPointsFlagEnabled && share.shareOption === EUserRole.OWNER) {
    <a
      id="importPointsBtn"
      data-m-target="Import points dropdown button"
      class="dropdownItem"
      (click)="hideDropdown(ESiteSettingsPaths.IMPORT_POINTS)"
    >
      {{ 'site_settings_tabs_import_points' | ppTranslate }}
    </a>
  }
  <a
    id="manageTagsBtn"
    data-m-target="Edit site tags dropdown button"
    class="dropdownItem"
    (click)="hideDropdown(ESiteSettingsPaths.TAGS)"
  >
    {{ 'manage_tags' | ppTranslate }}
  </a>
  <a
    id="manageCFBtn"
    data-m-target="Edit site custom fields dropdown button"
    class="dropdownItem"
    (click)="hideDropdown(ESiteSettingsPaths.CUSTOM_FIELDS)"
  >
    {{ 'manage_custom_fields' | ppTranslate }}
  </a>
  <a
    id="manageUsersBtn"
    data-m-target="Edit site users dropdown button"
    class="dropdownItem"
    (click)="hideDropdown(ESiteSettingsPaths.USERS)"
  >
    {{ 'manage_users' | ppTranslate }}
  </a>
  @if (share.shareOption === EUserRole.OWNER) {
    <a
      id="sitePlanSettingsBtn"
      data-m-target="Edit site plan dropdown button"
      class="dropdownItem"
      (click)="hideDropdown(ESiteSettingsPaths.PLAN)"
    >
      {{ 'site_plan' | ppTranslate }}
    </a>

    <a
      id="siteLogoSettingsBtn"
      data-m-target="Edit site logo button"
      class="dropdownItem"
      (click)="hideDropdown(ESiteSettingsPaths.LOGO)"
    >
      {{ 'pdf_logo_header' | ppTranslate }}
    </a>
  }
  @if (integrationsEnabled) {
    <a
      id="integrationsSettingBtn"
      data-m-target="Site integrations button"
      class="dropdownItem"
      (click)="hideDropdown(ESiteSettingsPaths.INTEGRATIONS)"
    >
      {{ 'integrations' | ppTranslate }}
    </a>
  }
  <ng-container>
    <hr class="headerOptions__hr" />
    <a
      id="siteDeleteSettingsBtn"
      data-m-target="Delete site button"
      class="dropdownItem"
      (click)="deleteSite()"
      (mouseenter)="onDeleteHover(true)"
      (mouseleave)="onDeleteHover(false)"
    >
      <span class="deleteSite__text">
        {{ 'delete_site' | ppTranslate }}
      </span>
      <pp-icon
        [ppSrc]="EIconPath.ICON_BADGE_INFO"
        ppTooltip
        [ppSanitize]="false"
        [ppTitle]="'delete_site_tooltip' | ppTranslate"
        class="deleteSite__info"
        [ppColor]="deleteHover ? 'white' : 'grey-600'"
      ></pp-icon>
    </a>
  </ng-container>
}
